<template>
  <div class="cotainer card-item">
    <div class="title-box">
      <span class="title-text">{{ cardTitle }}</span>
    </div>
    <div class="title-boxs">
      <span class="btn-action-group">
        <!-- v-if="oldInfos?.id && !isEdit" -->
        <a-button type="primary" @click="addSource()" class="btn-action"
          >新增</a-button
        >
        <!-- <a-button @click="importsj(1)" class="btn-action" v-if="oldInfos?.id  && !isEdit"
          >导入</a-button
        > -->
        <!-- v-if="oldInfos?.id  && !isEdit" -->
        <a-button class="btn-action" danger type="text" @click="batchDelete">
          批量移除</a-button
        >
      </span>
    </div>
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template
          style="width: 100px"
          slot="capitalSource"
          slot-scope="text, record"
        >
          <tr
            v-for="(item, index) in record.lxSubsidyFundCostList"
            :key="index"
            :style="
              index + 1 == record.lxSubsidyFundCostList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.project">
              <span>{{ item.project }}</span>
            </div>
          </tr>
          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
        </template>
        <template style="width: 100px" slot="name" slot-scope="text, record">
          <tr
            v-for="(item, index) in record.lxSubsidyFundCostList"
            :key="index"
            :style="
              index + 1 == record.lxSubsidyFundCostList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.amount">
              <span>{{ item.amount }}</span>
            </div>
          </tr>
          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
        </template>
        <!-- v-if="oldInfos?.id && !isEdit" -->
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record, index)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record, index)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
        </span>
        <!-- <template
          slot="action"
          slot-scope="record"
          style="margin: 0 20px"
          v-if="oldInfos?.id  && !isEdit"
        >
          <tr class="table-tr">
            <div
              class="table-content"
              style="
                justify-content: space-between;
                padding: 0px 50px;
                box-sizing: border-box;
              "
            >
              <div
                class="flex align-items-center"
                style="cursor: pointer"
                @click="editInfo(record, index)"
              >
                <img
                  class="img-box"
                  src="../../assets/images/img42.png"
                  alt=""
                />
                <span>编辑</span>
              </div>
              <div
                class="flex align-items-center"
                style="cursor: pointer"
                @click="deleteInfo(record, index)"
              >
                <img
                  class="img-box"
                  src="../../assets/images/img43.png"
                  alt=""
                />
                <span>移除</span>
              </div>
            </div>
          </tr>
        </template> -->
      </a-table>
    </div>
    <!-- 添加资金来源 -->
    <found-source ref="foundSource" @foundPay="foundPays"></found-source>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条预算的数据吗?</p>
    </a-modal>
    <data-import ref="dataImport" @refreshData="foundPay"></data-import>
  </div>
</template>
    
	<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";

import foundSource from "./addSource.vue";

const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "年份",
    dataIndex: "vintages",
    id: "vintages",
    align: "center",
    width: 150,
  },
  // {
  // 	title: "资金名称",
  // 	dataIndex: "name",
  // 	id: "name",
  // 	align: "center",
  // 	width: 150,
  // },
  {
    title: "资金来源",
    // dataIndex: "capitalSource_dictText",
    // id: "capitalSource_dictText",
    dataIndex: "capitalSource",
    id: "capitalSource",
    align: "center",
    width: 180,
  },
  {
    title: "资金金额",
    dataIndex: "amount",
    id: "amount",
    align: "center",
    width: 160,
  },
  // 	{
  // 	title: "支出项目",
  // 	dataIndex: "createTime",
  // 	id: "createTime",
  // 	align: "center",
  // 	width: 150,
  // 	scopedSlots: { customRender: "capitalSource" },
  // },
  // {
  //   title: "剩余金额",
  //   dataIndex: "surplusAmount",
  //   id: "surplusAmount",
  //   align: "center",
  //   width: 150,
  // },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 234,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      yearShowOne: false,
      selectedRowKeys: [],
      isEdit: false,
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    cardTitle: {
      type: String,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  components: {
    foundSource,
    dataImport,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  watch: {
    "oldInfos.capitalBudgetinglist": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.foundPay();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    // console.log("budget mounted oldInfos", this.oldInfos);
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    this.getData();
  },
  methods: {
    importsj(num) {
      if (num == "1") {
        this.$refs.dataImport.init("fund", this.oldInfos, "资金来源");
      } else if (num == "2") {
        this.$refs.dataImport.init("fundcost", this.oldInfos, "资金支出");
      }
    },
    addSource() {
      // console.log("addSource this.oldInfos", this.oldInfos);
      // console.log("this.$refs.foundSource", this.$refs.foundSource);
      this.$refs.foundSource.init("add", this.oldInfos);
    },
    addPay() {
      this.$refs.foundPay.init("add", this.oldInfos);
    },
    foundPays(sj) {
      if (sj.type == "add") {
        this.pagination.current = 1;
        this.oldInfos.capitalBudgetinglist.unshift({
          ...sj.record,
          id:
            sj.record.name +
            (sj.record.capitalSource +
              sj.record.amount +
              this.oldInfos.capitalBudgetinglist.length),
        });
      } else {
        let index = this.oldInfos.capitalBudgetinglist.findIndex(
          (item) => item.id === sj.record.id
        );
        // console.log(sj.record.id,this.oldInfos.capitalBudgetinglist);
        if (index !== -1) {
          // 如果找到相同的 id，替换该对象
          this.oldInfos.capitalBudgetinglist[index] = sj.record;
        }
      }
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      this.getData();
    },
    foundPay() {
      //this.pagination.current = 1;

      this.getData();
    },
    getData() {
      console.log("this.pagination.current", this.pagination.current);
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxBase/lxSubsidyFund/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.capitalBudgetinglist &&
          this.oldInfos.capitalBudgetinglist.length > 0
        ) {
          console.log("this.pagination.current", this.pagination.current);
          this.pagination.total = this.oldInfos.capitalBudgetinglist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          let formatList = this.oldInfos.capitalBudgetinglist.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.capitalBudgetinglist.slice(
              startIndex,
              endIndex
            );
          }
          this.dataList = formatList;
          console.log("this.dataList", this.dataList);
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    handleOk() {
      this.$message.success("移除成功");
      this.showDeleteModel = false;
      this.oldInfos.capitalBudgetinglist =
        this.oldInfos.capitalBudgetinglist.filter(
          (item) => item.id != this.deteleId
        );
      sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
      console.log("this.pagination.current", this.pagination.current);
      this.getData();
      // deleteAction("/lxBase/lxSubsidyFund/delete", {
      //   id: this.deteleId,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("移除成功");
      //     this.showDeleteModel = false;
      //     this.getData();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    deleteInfo(row, index) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row, index) {
      this.$refs.foundSource.init("edit", row, index);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.year = ""; // 或者适当的空值，根据你的业务需求
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      this.form.joinYear = value;
      this.$refs.ruleForm.clearValidate("year");
      this.yearShowOne = false;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      // let applyType = 1;
      // if (this.$route.name === "szStudio") {
      //   applyType = 1;
      // } else if (this.$route.name === "educationalBrand") {
      //   applyType = 2;
      // } else {
      //   applyType = 3;
      // }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的预算");
      } else {
        //this.pagination.current = 1;
        // console.log(this.selectedRowKeys);
        this.oldInfos.capitalBudgetinglist =
          this.oldInfos.capitalBudgetinglist.filter(
            (item) => !this.selectedRowKeys.includes(item.id)
          );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
        this.selectedRowKeys = [];
        // let params = {
        //   ids: this.selectedRowKeys.toString(),
        // };
        // deleteAction("/lxBase/lxSubsidyFund/deleteBatch", params).then(
        //   (res) => {
        //     if (res.code == 200) {
        //       this.$message.success("批量移除成功");
        //       this.pagination.current=1;
        //       this.getData();
        //       this.selectedRowKeys = [];
        //       this.$forceUpdate();
        //     } else {
        //       this.$message.error(res.message);
        //     }
        //   }
        // );
      }
    },
  },
};
</script>
    
<style scoped="scoped" lang="scss">
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 37px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 20px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
    .title-boxs {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 20px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
    .cotainerhead {
      margin: 20px 0px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .add-btn {
        width: 100px;
        height: 30px;
        background: #2155b5;
        border-radius: 6px;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        line-height: 30px;
        margin-right: 10px;
        text-align: center;
      }
    }
  }
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #2155b5;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}
.big-box {
  width: 253px;
  margin: 50px auto 0px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.table-content {
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
// /deep/.ant-table-tbody > tr > td:nth-child(5),
// /deep/.ant-table-tbody > tr > td:nth-child(4) {
//   padding: 0 !important;
// }
// /deep/.ant-table-tbody > tr > td {
//   padding: 0 !important;
//   height: 60px;
// }
</style>